import * as z from "zod";

export const semanticSearchTeams = {
  name: "semanticSearchTeams" as const,
  input: z.object({
    query: z.string().min(1, "Query cannot be empty"),
    limit: z.number().int().positive().optional().default(50),
  }),
  output: z.object({ teamIds: z.array(z.string()) }),
};
